import { ArgsType, Field, Int } from '@nestjs/graphql'
import { MaxLength, MinLength } from '@nestjs/class-validator'
import { bsConstants } from '../../../module.constants'

@ArgsType()
export class UserSignupDto {
  @Field()
  emailAddress!: string

  @Field()
  @MinLength(bsConstants.USER.PASSWORDS.MIN_LENGTH, { message: 'minPasswordLength' })
  @MaxLength(bsConstants.USER.PASSWORDS.MAX_LENGTH, { message: 'maxPasswordLength' })
  password!: string

  @Field(type => Int)
  role!: number
}
